import React from 'react';
import styled from 'styled-components';

const RangeSlider = styled.input`
  width: 100%;
  -webkit-appearance: none;
  appearance: none;

  &::-webkit-slider-runnable-track {
    background: ${(p) => p.theme.global.colors['light-4']};
    height: 0.3rem;
    width: 100%;
    cursor: pointer;
  }

  &::-moz-range-track {
    background: ${(p) => p.theme.global.colors['light-4']};
    height: 0.5rem;
  }

  &::-webkit-slider-thumb {
    -webkit-appearance: none; /* Override default look */
    appearance: none;
    margin-top: -0.3rem; /* Centers thumb on the track */
    background-color: #000;
    height: 1rem;
    width: 1rem;
    border-radius: 100%;
    box-shadow: none;
  }

  @media only screen ${(p) =>
      `and (max-width: ${p.theme.global.breakpoints.small.value + 1}px)`} {
    &::-webkit-slider-thumb {
      height: 2rem;
      width: 2rem;
      margin-top: -0.8rem; /* Centers thumb on the track */
    }
  }
`;

const InputRangeSlider = (props) => <RangeSlider type="range" {...props} />;

export default InputRangeSlider;
